import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from './inputErrorMessage.scss';

function InputErrorMessage({ className, errorMessage }) {
  return (
    <span
      className={classNames(
        styleHelper.text15,
        styles.inputErrorMessage,
        className
      )}
    >
      {errorMessage || '\u00A0'}
    </span>
  );
}

InputErrorMessage.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default React.memo(InputErrorMessage);
